<!-- Shell reused from the shared confirm-dialog convention (styles/_confirm-dialog.scss),
     same as the "I Need Help" ticket modal. Opened with panelClass: 'confirm-dialog-panel'
     (reports.component.ts). -->
<div class="confirm-dialog">
  <button mat-icon-button class="dialog-close" type="button" aria-label="Close report dialog" [disabled]="isLoading"
    (click)="cancel()">
    <mat-icon>close</mat-icon>
  </button>

  <div class="dialog-icon icon-blue">
    <mat-icon>{{ hasInputs ? 'date_range' : 'download' }}</mat-icon>
  </div>

  <h2 class="dialog-title">{{ data.report.name }}</h2>

  <form [formGroup]="form" (ngSubmit)="download()">
    <div class="dialog-message report-form">
      <p class="report-hint" *ngIf="hasInputs; else noInputs">
        {{ isYearOnly ? 'Choose the year' + (showStartDate && showEndDate ? ' range' : '') : 'Choose the date range' }}
        for this report.
      </p>
      <ng-template #noInputs>
        <p class="report-hint">This report needs no filters. It will be downloaded as {{ format.toUpperCase() }}.</p>
      </ng-template>

      <div class="date-range-container" *ngIf="hasInputs">
        <mat-form-field appearance="outline" class="date-field compact-field" *ngIf="showStartDate">
          <mat-label>{{ startLabel }}</mat-label>
          <input matInput [matDatepicker]="picker1" formControlName="start" [min]="minDate" [max]="maxDate"
            [matDatepickerFilter]="startDateFilter" [placeholder]="isYearOnly ? 'Choose a year' : 'Choose a date'">
          <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
          <mat-datepicker #picker1 [startView]="isYearOnly ? 'multi-year' : 'month'"
            (yearSelected)="isYearOnly ? chosenYearHandler($event, picker1, 'start') : null"
            [panelClass]="isYearOnly ? 'year-only-picker' : ''"></mat-datepicker>
          <mat-error *ngIf="form.get('start')?.hasError('required')">Required.</mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline" class="date-field compact-field" *ngIf="showEndDate">
          <mat-label>{{ endLabel }}</mat-label>
          <input matInput [matDatepicker]="picker2" formControlName="end" [min]="minDate" [max]="maxDate"
            [matDatepickerFilter]="endDateFilter" [placeholder]="isYearOnly ? 'Choose a year' : 'Choose a date'">
          <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
          <mat-datepicker #picker2 [startView]="isYearOnly ? 'multi-year' : 'month'"
            (yearSelected)="isYearOnly ? chosenYearHandler($event, picker2, 'end') : null"
            [panelClass]="isYearOnly ? 'year-only-picker' : ''"></mat-datepicker>
          <mat-error *ngIf="form.get('end')?.hasError('required')">Required.</mat-error>
        </mat-form-field>
      </div>

      <mat-error *ngIf="form.hasError('dateRangeInvalid')" class="range-error">
        {{ isYearOnly ? 'To year must be greater than or equal to from year' : 'End date must be greater than or equal to start date' }}
      </mat-error>
    </div>

    <div class="dialog-actions">
      <button mat-stroked-button class="cancel-btn" type="button" [disabled]="isLoading" (click)="cancel()">
        Cancel
      </button>
      <button mat-raised-button class="confirm-btn btn-blue" type="submit" [disabled]="form.invalid || isLoading">
        <mat-icon *ngIf="!isLoading">download</mat-icon>
        {{ isLoading ? 'Downloading…' : 'Download ' + format.toUpperCase() }}
      </button>
    </div>
  </form>
</div>
